import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import "../../../components/LoadingSpinner/spinner.css";
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  
} from "@mui/material";
import { Tooltip } from "antd";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../../src/components/CustomButton/CustomButton";
import { Card, Alert, Modal, ModalHeader } from "reactstrap";
import AddNewBank from "./AddNewBank";
import { resetbankMasterView, bankMasterView } from "../../../redux/actions/bankMasterViewAction";


const useStyles = makeStyles({
  table: {
      minWidth: 650,
  },
});

function BankMasterList() {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openModal, setopenModal] = useState(false);
  const [action, setaction] = useState("");

  const classes = useStyles();
  const dispatch = useDispatch();

  const login = useSelector(({ login }) => login);
  const bankmasterlist = useSelector(({ bankMasterlist }) => bankMasterlist);
  const bankMasteraddupdate = useSelector(({ bankMasterAddUpdate }) => bankMasterAddUpdate);
  const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const viewEditHandler = (data, value) => {
    setaction(value);
    bankMasterViewHandler(data)
    setopenModal(!openModal);
  }

  const bankMasterViewHandler = (id) => {

    const req = {
        actionCustomerMasterRequestVO : {
            bankId : login.data.partnerId,
            id: id,
        }
    }

    if(regenerateTokenRes.success){
        dispatch(bankMasterView(req, regenerateTokenRes.data.AuthToken))
    }
  }

  useEffect(() => {
    if(bankMasteraddupdate.success){
        setopenModal(false); 
    }
}, [bankMasteraddupdate])

  return (
    <>
      {bankmasterlist.isloading ? <LoadingSpinner /> 
       : bankmasterlist.success && bankmasterlist.data.errorList ? (
        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px",
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}>
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow className="themeBackground">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank Name	{" "}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Branch Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    District
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Account Number
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Routing Number
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {bankmasterlist.success &&
												[]
                                                .concat(bankmasterlist.data.errorList)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell align="center">
                                                        {row.bankName}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.branchName}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.district}
                                                    </TableCell>
                                                    <TableCell align="center">{row.accountNumber}</TableCell>
                                                    <TableCell align="center">{row.routingCode}</TableCell>
                                                    <TableCell align="center">
                                                        <>
                                                        <Tooltip title="View">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() => viewEditHandler(row.customerId, "viewBankMaster")}
                                                                    >
                                                                        {
                                                                            <VisibilityIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>

                                                                <Tooltip title="Edit">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() => viewEditHandler(row.customerId, "updateBankMaster")}
                                                                    >
                                                                        {
                                                                            <EditIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>
                                                        </>
                                                    </TableCell>
                                                </TableRow>
											))}
                                        </TableBody>
                                        </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(bankmasterlist.data.errorList).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
      ) : (
        <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px",
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 themeBackground"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
      )}

            {openModal && <Modal
                isOpen={openModal}
                toggle={viewEditHandler}
                size="lg"            >
                <ModalHeader toggle={viewEditHandler}>Bank Master Details</ModalHeader>
                {/* <ModalBody className="password-modal-body"> */}
                <AddNewBank action={action} />
                {/* </ModalBody> */}
            </Modal>}
    </>
  )
}

export default BankMasterList